var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-chip',_vm._g({class:{ strikethrough: _vm.chip.strikeThrough, 'lighten-4': _vm.disabled },attrs:{"small":"","color":_vm.chip.colour}},on),[_vm._v(" "+_vm._s(_vm.truncatedProduct)+" ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.product))])])}
var staticRenderFns = []

export { render, staticRenderFns }